import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { VALKEY_PATHS } from './paths';

/** Valkey: ключ (Material Icons «vpn_key», Apache 2.0). */
export const ValkeyIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {VALKEY_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
